import React from "react";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {Checkbox, withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import TableCell from "@material-ui/core/TableCell";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import DescriptionIcon from "@material-ui/icons/Description";
import {Link} from "react-admin";

const StyledTableCell = withStyles((theme: any) => ({
    head: {
        color: theme.palette.common.black,
        fontWeight: 600,
        fontSize: '0.95rem',
        opacity: "90%"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme: any) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        },
        transition: 'background-color 0.2s ease',
    },
}))(TableRow);


type Delivery = {
    client: number;
    province: string;
    address: string;
    locality: string;
    weight: number | null;
    totD: number | null;
    packages_number: number | null;
    volume: number | null;
    files: any[];
};


type SummaryRow = {
    business_name: string;
    province: string;
    address: string;
    locality: string;
    id: number;
    totD: number;
    totW: number;
    totP: number;
    totV: number;
    deliveries: Delivery[];
};


type RowProps = {
    row: SummaryRow;
    viewType: 'receiver' | 'client';
    classes: any,
    setSelectedRow?: Function
    selectedRow?: any[];
};

export function RowSummary({row, viewType, classes, setSelectedRow, selectedRow}: RowProps) {
    const [open, setOpen] = React.useState(false);

    const mainLabel = viewType === 'client' ? 'Destinatario' : 'Cliente';

    return (
        <React.Fragment>
            <StyledTableRow>

                <StyledTableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                        style={{
                            transition: 'transform 0.2s ease',
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                    >
                        <KeyboardArrowDownIcon/>
                    </IconButton>
                </StyledTableCell>
                {
                    (setSelectedRow && selectedRow) && <StyledTableCell>
                        <Checkbox
                            checked={selectedRow.includes(row)}
                            onChange={(event, checked) => checked ? setSelectedRow([...selectedRow, row]) : setSelectedRow(selectedRow?.filter((value)=> value != row))}
                        />
                    </StyledTableCell>
                }
                <StyledTableCell component="th" scope="row">
                    <Typography variant="body1" style={{fontWeight: 500}}>
                        {row.business_name}
                    </Typography>
                </StyledTableCell>
                <StyledTableCell>
                    {row.address} ({row.locality} - {row.province})
                </StyledTableCell>
                <StyledTableCell align="right">
                    <Chip
                        label={row.totD}
                        size="small"
                        className={classes.totalsChip}
                        color="primary"
                        variant="outlined"
                    />
                </StyledTableCell>
                <StyledTableCell align="right">
                    <Chip
                        label={row.totP}
                        size="small"
                        className={classes.totalsChip}
                        color="primary"
                        variant="outlined"
                    />
                </StyledTableCell>
                <StyledTableCell align="right">
                    <Chip
                        label={`${row.totW} kg`}
                        size="small"
                        className={classes.totalsChip}
                        color="secondary"
                        variant="outlined"
                    />
                </StyledTableCell>
                <StyledTableCell align="right">
                    <Chip
                        label={`${row.totV} m³`}
                        size="small"
                        className={classes.totalsChip}
                        style={{borderColor: '#4caf50', color: '#4caf50'}}
                        variant="outlined"
                    />
                </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
                <TableCell
                    style={{paddingBottom: 0, paddingTop: 0, backgroundColor: '#fafafa'}}
                    colSpan={8}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Table aria-label="deliveries" className={classes.nestedTable}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{fontWeight: 600}}>
                                            {mainLabel}
                                        </TableCell>
                                        <TableCell>
                                            Località
                                        </TableCell>
                                        <TableCell align="right" style={{fontWeight: 600}}>
                                            Missioni
                                        </TableCell>
                                        <TableCell align="right" style={{fontWeight: 600}}>
                                            Colli
                                        </TableCell>
                                        <TableCell align="right" style={{fontWeight: 600}}>
                                            Peso (kg)
                                        </TableCell>
                                        <TableCell align="right" style={{fontWeight: 600}}>
                                            Volume (m³)
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.entries(row.deliveries).map(([key, value]) => (
                                        <React.Fragment key={key}>
                                            <TableRow>
                                                <TableCell component="th" scope="row">
                                                    <Typography variant="body2" style={{fontWeight: 500}}>
                                                        {key}
                                                    </Typography>
                                                </TableCell>
                                                <StyledTableCell>
                                                    {value.address} ({value.locality} - {value.province})
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    {value.totD ?? '-'}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {value.packages_number ?? '-'}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {value.weight ?? '-'}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {value.volume ?? '-'}
                                                </TableCell>
                                            </TableRow>
                                            {Object.entries(value.files).map(([fileKey, fileValue]) => (
                                                <TableRow key={fileKey} className={classes.fileRow}>
                                                    <TableCell></TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        className={classes.fileCell}
                                                    >
                                                        <DescriptionIcon className={classes.fileIcon}/>
                                                        <Typography
                                                            variant="body2"
                                                            component="span"
                                                            style={{fontSize: '0.85rem', color: '#546e7a'}}
                                                        >
                                                            <Link to={`deliveries?filter={"import_file":${fileKey}}`}
                                                                  target="_blank">{fileKey}</Link>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="right" style={{fontSize: '0.85rem'}}>
                                                        {fileValue.totD ?? '-'}
                                                    </TableCell>
                                                    <TableCell align="right" style={{fontSize: '0.85rem'}}>
                                                        {fileValue.packages_number ?? '-'}
                                                    </TableCell>
                                                    <TableCell align="right" style={{fontSize: '0.85rem'}}>
                                                        {fileValue.weight ?? '-'}
                                                    </TableCell>
                                                    <TableCell align="right" style={{fontSize: '0.85rem'}}>
                                                        {fileValue.volume ?? '-'}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </StyledTableRow>
        </React.Fragment>
    );
}
